export const getDesignerFromSlug = (slug: string) => {
  const removeWords = ["dress", "hire"];
  const slugWords = slug.split("-");
  const designerWords = slugWords.filter((w) => !removeWords.includes(w));
  return designerWords.join("-");
};
